import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";

const PaymentForm = () => (
	<div>
		<Field customlabel="Paiement Servipay disponible" component={Checkbox} name="servipayAvailable" id="servipayAvailable" required />
		<Field customlabel="Paiement Sumup disponible" component={Checkbox} name="sumupAvailable" id="sumupAvailable" required />
		<Field customlabel="Paiement en espèces disponible" component={Checkbox} name="cashAvailable" id="cashAvailable" required />
		<Field customlabel="Paiement via une facture disponible" component={Checkbox} name="invoicesAvailable" id="invoicesAvailable" required />
	</div>
);

export default PaymentForm;
